export const COMPANION_APP_URL =
  process.env.REACT_APP_COMPANION_APP_URL ||
  process.env.REACT_APP_COMPANION_API_URL ||
  'https://cpc.qwabi.lat';
